import React from "react";

export default function Chat() {
	return <div className="p-5">Chat</div>;
}
